/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../Fixes';
import Builder from '../../Builder';
import '../common/time';
import '../../google/protobuf/field_mask';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "banking": {
        "nested": {
          "card_invitation": {
            "nested": {
              "Name": {
                "fields": {
                  "full": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "first": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  },
                  "middle": {
                    "type": "string",
                    "id": 3,
                    "rule": "optional"
                  },
                  "last": {
                    "type": "string",
                    "id": 4,
                    "rule": "optional"
                  },
                  "nickname": {
                    "type": "string",
                    "id": 5,
                    "rule": "optional"
                  }
                }
              },
              "CardInvitation": {
                "fields": {
                  "id": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "inviter": {
                    "type": ".squareup.banking.card_invitation.CardInvitation.Inviter",
                    "id": 2,
                    "rule": "optional"
                  },
                  "invitee": {
                    "type": ".squareup.banking.card_invitation.CardInvitation.Invitee",
                    "id": 3,
                    "rule": "optional"
                  },
                  "state": {
                    "type": ".squareup.banking.card_invitation.CardInvitation.State",
                    "id": 4,
                    "rule": "optional"
                  },
                  "expiresAt": {
                    "type": ".squareup.common.time.DateTime",
                    "id": 5,
                    "rule": "optional"
                  }
                },
                "nested": {
                  "State": {
                    "values": {
                      "STATE_NONE": 0,
                      "STATE_OPEN": 1,
                      "STATE_CLAIMED": 2,
                      "STATE_EXPIRED": 3,
                      "STATE_REVOKED": 4,
                      "STATE_ARCHIVED": 5
                    }
                  },
                  "Inviter": {
                    "fields": {
                      "name": {
                        "type": ".squareup.banking.card_invitation.Name",
                        "id": 1,
                        "rule": "optional"
                      },
                      "businessName": {
                        "type": "string",
                        "id": 2,
                        "rule": "optional"
                      }
                    }
                  },
                  "Invitee": {
                    "fields": {
                      "name": {
                        "type": ".squareup.banking.card_invitation.Name",
                        "id": 1,
                        "rule": "optional"
                      },
                      "emailAddress": {
                        "type": "string",
                        "id": 2,
                        "rule": "optional"
                      }
                    }
                  }
                }
              },
              "OpenCardInvitationRequest": {
                "fields": {
                  "cardInvitationId": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  }
                }
              },
              "OpenCardInvitationResponse": {
                "fields": {}
              },
              "RetrieveCardInvitationRequest": {
                "fields": {
                  "cardInvitationId": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "fieldMask": {
                    "type": ".google.protobuf.FieldMask",
                    "id": 2,
                    "rule": "optional"
                  }
                }
              },
              "RetrieveCardInvitationResponse": {
                "fields": {
                  "cardInvitation": {
                    "type": ".squareup.banking.card_invitation.CardInvitation",
                    "id": 1,
                    "rule": "optional"
                  }
                }
              },
              "RevokeCardInvitationRequest": {
                "fields": {
                  "cardInvitationId": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  }
                }
              },
              "RevokeCardInvitationResponse": {
                "fields": {}
              },
              "SendCardInvitationRequest": {
                "fields": {
                  "cardInvitationId": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "idempotenceToken": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  }
                }
              },
              "SendCardInvitationResponse": {
                "fields": {}
              },
              "ClaimCardInvitationRequest": {
                "fields": {
                  "cardInvitationId": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "cardToken": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  }
                }
              },
              "ClaimCardInvitationResponse": {
                "fields": {}
              },
              "UserCardInvitationService": {
                "methods": {
                  "OpenCardInvitation": {
                    "requestType": ".squareup.banking.card_invitation.OpenCardInvitationRequest",
                    "responseType": ".squareup.banking.card_invitation.OpenCardInvitationResponse"
                  },
                  "RetrieveCardInvitation": {
                    "requestType": ".squareup.banking.card_invitation.RetrieveCardInvitationRequest",
                    "responseType": ".squareup.banking.card_invitation.RetrieveCardInvitationResponse"
                  },
                  "RevokeCardInvitation": {
                    "requestType": ".squareup.banking.card_invitation.RevokeCardInvitationRequest",
                    "responseType": ".squareup.banking.card_invitation.RevokeCardInvitationResponse"
                  },
                  "SendCardInvitation": {
                    "requestType": ".squareup.banking.card_invitation.SendCardInvitationRequest",
                    "responseType": ".squareup.banking.card_invitation.SendCardInvitationResponse"
                  },
                  "ClaimCardInvitation": {
                    "requestType": ".squareup.banking.card_invitation.ClaimCardInvitationRequest",
                    "responseType": ".squareup.banking.card_invitation.ClaimCardInvitationResponse"
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.banking?.nested?.card_invitation?.nested?.Name && !$root.nested?.squareup?.nested?.banking?.nested?.card_invitation?.nested?.CardInvitation && !$root.nested?.squareup?.nested?.banking?.nested?.card_invitation?.nested?.CardInvitation?.nested?.State && !$root.nested?.squareup?.nested?.banking?.nested?.card_invitation?.nested?.CardInvitation?.nested?.Inviter && !$root.nested?.squareup?.nested?.banking?.nested?.card_invitation?.nested?.CardInvitation?.nested?.Invitee && !$root.nested?.squareup?.nested?.banking?.nested?.card_invitation?.nested?.OpenCardInvitationRequest && !$root.nested?.squareup?.nested?.banking?.nested?.card_invitation?.nested?.OpenCardInvitationResponse && !$root.nested?.squareup?.nested?.banking?.nested?.card_invitation?.nested?.RetrieveCardInvitationRequest && !$root.nested?.squareup?.nested?.banking?.nested?.card_invitation?.nested?.RetrieveCardInvitationResponse && !$root.nested?.squareup?.nested?.banking?.nested?.card_invitation?.nested?.RevokeCardInvitationRequest && !$root.nested?.squareup?.nested?.banking?.nested?.card_invitation?.nested?.RevokeCardInvitationResponse && !$root.nested?.squareup?.nested?.banking?.nested?.card_invitation?.nested?.SendCardInvitationRequest && !$root.nested?.squareup?.nested?.banking?.nested?.card_invitation?.nested?.SendCardInvitationResponse && !$root.nested?.squareup?.nested?.banking?.nested?.card_invitation?.nested?.ClaimCardInvitationRequest && !$root.nested?.squareup?.nested?.banking?.nested?.card_invitation?.nested?.ClaimCardInvitationResponse && !$root.nested?.squareup?.nested?.banking?.nested?.card_invitation?.nested?.UserCardInvitationService) {
  $root.addJSON(jsonData);
}

/**
 * NOTE(steckel) Copied from squareup.person.Profile.Name (including comment).
 * TODO(steckel) Consider extracting into a higher, shared location.
 *
 * We won't always have structured first and last name.
 * In some cases first/last doesn't internationalize well.
 * Alternatively, a person might be a business and the name on the receipt needs to be the
 * business name for tax purposes.
 *
 * Either a full name or first/last names must be set - potentially both are set.
 * All other fields are optional.
 *
 * SOURCE Name @ squareup/banking/card_invitation.proto at 27:1
 */
export const Name = $root.lookupType('squareup.banking.card_invitation.Name');
fixType(Name);
Builder.createAndAttachToType(Name);
/**
 * The customer-facing CardInvitation domain model.
 *
 * SOURCE CardInvitation @ squareup/banking/card_invitation.proto at 41:1
 */
export const CardInvitation = $root.lookupType('squareup.banking.card_invitation.CardInvitation');
fixType(CardInvitation);
Builder.createAndAttachToType(CardInvitation);
/**
 * SOURCE State @ squareup/banking/card_invitation.proto at 48:5
 */
CardInvitation.State = $root.lookupEnum('squareup.banking.card_invitation.CardInvitation.State').values;
/**
 * SOURCE Inviter @ squareup/banking/card_invitation.proto at 57:5
 */
CardInvitation.Inviter = $root.lookupType('squareup.banking.card_invitation.CardInvitation.Inviter');
fixType(CardInvitation.Inviter);
Builder.createAndAttachToType(CardInvitation.Inviter);
/**
 * SOURCE Invitee @ squareup/banking/card_invitation.proto at 66:5
 */
CardInvitation.Invitee = $root.lookupType('squareup.banking.card_invitation.CardInvitation.Invitee');
fixType(CardInvitation.Invitee);
Builder.createAndAttachToType(CardInvitation.Invitee);
/**
 * SOURCE OpenCardInvitationRequest @ squareup/banking/card_invitation.proto at 76:1
 */
export const OpenCardInvitationRequest = $root.lookupType('squareup.banking.card_invitation.OpenCardInvitationRequest');
fixType(OpenCardInvitationRequest);
Builder.createAndAttachToType(OpenCardInvitationRequest);
/**
 * SOURCE OpenCardInvitationResponse @ squareup/banking/card_invitation.proto at 80:1
 */
export const OpenCardInvitationResponse = $root.lookupType('squareup.banking.card_invitation.OpenCardInvitationResponse');
fixType(OpenCardInvitationResponse);
Builder.createAndAttachToType(OpenCardInvitationResponse);
/**
 * SOURCE RetrieveCardInvitationRequest @ squareup/banking/card_invitation.proto at 82:1
 */
export const RetrieveCardInvitationRequest = $root.lookupType('squareup.banking.card_invitation.RetrieveCardInvitationRequest');
fixType(RetrieveCardInvitationRequest);
Builder.createAndAttachToType(RetrieveCardInvitationRequest);
/**
 * SOURCE RetrieveCardInvitationResponse @ squareup/banking/card_invitation.proto at 87:1
 */
export const RetrieveCardInvitationResponse = $root.lookupType('squareup.banking.card_invitation.RetrieveCardInvitationResponse');
fixType(RetrieveCardInvitationResponse);
Builder.createAndAttachToType(RetrieveCardInvitationResponse);
/**
 * SOURCE RevokeCardInvitationRequest @ squareup/banking/card_invitation.proto at 91:1
 */
export const RevokeCardInvitationRequest = $root.lookupType('squareup.banking.card_invitation.RevokeCardInvitationRequest');
fixType(RevokeCardInvitationRequest);
Builder.createAndAttachToType(RevokeCardInvitationRequest);
/**
 * SOURCE RevokeCardInvitationResponse @ squareup/banking/card_invitation.proto at 95:1
 */
export const RevokeCardInvitationResponse = $root.lookupType('squareup.banking.card_invitation.RevokeCardInvitationResponse');
fixType(RevokeCardInvitationResponse);
Builder.createAndAttachToType(RevokeCardInvitationResponse);
/**
 * SOURCE SendCardInvitationRequest @ squareup/banking/card_invitation.proto at 97:1
 */
export const SendCardInvitationRequest = $root.lookupType('squareup.banking.card_invitation.SendCardInvitationRequest');
fixType(SendCardInvitationRequest);
Builder.createAndAttachToType(SendCardInvitationRequest);
/**
 * SOURCE SendCardInvitationResponse @ squareup/banking/card_invitation.proto at 102:1
 */
export const SendCardInvitationResponse = $root.lookupType('squareup.banking.card_invitation.SendCardInvitationResponse');
fixType(SendCardInvitationResponse);
Builder.createAndAttachToType(SendCardInvitationResponse);
/**
 * SOURCE ClaimCardInvitationRequest @ squareup/banking/card_invitation.proto at 104:1
 */
export const ClaimCardInvitationRequest = $root.lookupType('squareup.banking.card_invitation.ClaimCardInvitationRequest');
fixType(ClaimCardInvitationRequest, {
  cardInvitationId: {
    required: true
  },
  cardToken: {
    required: true
  }
});
Builder.createAndAttachToType(ClaimCardInvitationRequest);
/**
 * SOURCE ClaimCardInvitationResponse @ squareup/banking/card_invitation.proto at 109:1
 */
export const ClaimCardInvitationResponse = $root.lookupType('squareup.banking.card_invitation.ClaimCardInvitationResponse');
fixType(ClaimCardInvitationResponse);
Builder.createAndAttachToType(ClaimCardInvitationResponse);
/**
 * The application-layer invitation service. This exposes business-logic workflows around a
 * canonical CardInvitation object safe to exposing to clients and customers.
 *
 * SOURCE UserCardInvitationService @ squareup/banking/card_invitation.proto at 115:1
 */
export const UserCardInvitationService = $root.lookupService('squareup.banking.card_invitation.UserCardInvitationService');